import { render, staticRenderFns } from "./ProgramSynthesis.vue?vue&type=template&id=ebd54da6&scoped=true&"
import script from "./ProgramSynthesis.vue?vue&type=script&lang=js&"
export * from "./ProgramSynthesis.vue?vue&type=script&lang=js&"
import style0 from "./ProgramSynthesis.vue?vue&type=style&index=0&id=ebd54da6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd54da6",
  null
  
)

export default component.exports